import React from 'react';

const AboutUs = () => (
  <div className="section">
    
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '40px', marginBottom: '30px' }}>
      
      <div style={{ flex: '1 1 300px', minWidth: '280px', textAlign: 'center' }}>
        <h2>About Us</h2>
        <p>
          Vinyl records, CDs, DVDs, comic books, art, live music, books, t-shirts,
          collectibles, just a cool place to be.
        </p>
      </div>

      <div style={{ flex: '1 1 300px', minWidth: '280px', textAlign: 'center' }}>
        <h2>Contact</h2>
        <p>Email: RastaCowboyRecords@outlook.com</p>
        <p>Phone: (714) 319-2222</p>
        <p>Address: 155 E Main St, Tustin, CA</p>
      </div>
      
    </div>

    <div style={{ textAlign: 'center' }}>
      <img
        src="https://res.cloudinary.com/dnybxda3y/image/upload/v1751420286/store_blywpk.jpg"
        alt="Store"
        style={{
          maxWidth: '100%',
          height: 'auto',
          borderRadius: '12px',
        }}
      />
    </div>
    
  </div>
);

export default AboutUs;
